export function formatResponseErrors<T extends object>(data: T) {
    return Object.entries(data).reduce((acc, [key, value]) => {
        return { ...acc, [key]: Array.isArray(value) ? value.join(', ') : value };
    }, {} as Record<keyof T, string>);
}
